module.exports = __webpack_public_path__ + "static/media/1.91cd8d03.svg";